import { render } from "./Catalogue.vue?vue&type=template&id=1e769a5e"
import script from "./Catalogue.vue?vue&type=script&lang=js"
export * from "./Catalogue.vue?vue&type=script&lang=js"
script.render = render

export default script